class PureCarnivoreEssentials extends HTMLElement {
  constructor() {
    super();
    this.isDragging = false;
    this.hasDragged = false;
    this.startX = 0;
    this.startScrollLeft = 0;
  }

  connectedCallback() {
    this.track = this.querySelector('[data-essentials-track]');
    this.previousButton = this.querySelector('[data-essentials-previous]');
    this.nextButton = this.querySelector('[data-essentials-next]');

    if (!this.track || !this.previousButton || !this.nextButton || this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.previousButton.addEventListener('click', () => this.move(-1));
    this.nextButton.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
    this.track.addEventListener('keydown', (event) => this.onKeydown(event));
    this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event));
    this.track.addEventListener('pointermove', (event) => this.onPointerMove(event));
    this.track.addEventListener('pointerup', (event) => this.onPointerUp(event));
    this.track.addEventListener('pointercancel', (event) => this.onPointerUp(event));

    this.resizeObserver = new ResizeObserver(() => this.updateButtons());
    this.resizeObserver.observe(this.track);
    requestAnimationFrame(() => this.updateButtons());
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  getStepWidth() {
    const firstCard = this.track.querySelector('.pc-essentials__card');
    if (!firstCard) return this.track.clientWidth * 0.8;

    const styles = window.getComputedStyle(this.track);
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
    return firstCard.getBoundingClientRect().width + gap;
  }

  move(direction) {
    this.track.scrollBy({
      left: this.getStepWidth() * direction,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  onKeydown(event) {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.move(-1);
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.move(1);
    }
  }

  onPointerDown(event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;

    this.isDragging = true;
    this.hasDragged = false;
    this.startX = event.clientX;
    this.startScrollLeft = this.track.scrollLeft;
    this.track.classList.add('is-dragging');
    this.track.setPointerCapture(event.pointerId);
  }

  onPointerMove(event) {
    if (!this.isDragging) return;

    const distance = event.clientX - this.startX;
    if (Math.abs(distance) > 4) this.hasDragged = true;
    this.track.scrollLeft = this.startScrollLeft - distance;
  }

  onPointerUp(event) {
    if (!this.isDragging) return;

    this.isDragging = false;
    this.track.classList.remove('is-dragging');
    if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
    requestAnimationFrame(() => this.updateButtons());
  }

  updateButtons() {
    const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    this.previousButton.disabled = this.track.scrollLeft <= 2;
    this.nextButton.disabled = this.track.scrollLeft >= maximumScroll - 2;
  }
}

if (!customElements.get('purecarnivore-essentials')) {
  customElements.define('purecarnivore-essentials', PureCarnivoreEssentials);
}
